import { BaseBritishColumbiaObstetricalFileSubSection, BaseBritishColumbiaObstetricalFileSubSectionProps } from "@/Patient/Components/MedicalNote/Obstetric/Form/BritishColumbia/Subcomponent/BaseBritishColumbiaObstetricalFileSubSection";

class BritishColumbiaObstetricalInvestigationsAboRhFactor extends BaseBritishColumbiaObstetricalFileSubSection<BaseBritishColumbiaObstetricalFileSubSectionProps, never> {
    private readonly HemoglobinFirstTrimesterLabel = "T1";
    private readonly HemoglobinThirdTrimesterLabel = "T3";

    public render(): JSX.Element {
        const section13 = this.props.form.Section13.AboRhFactor;

        return (
            <div className="flex-display flex-col-gap-lg">
                <div className="flex-display" style={{ minWidth: "110px" }}>
                    {this.renderField({
                        label: "BloodGroupAcronymLabel",
                        field: this.controlRenderer.renderComboBox({
                            id: "bloodGroup-InvestigationsAboRhFactor",
                            selectedCode: section13.BloodGroup,
                            items: this.controlRenderer.getBloodGroupOptions(),
                            onChange: bloodGroup => this.props.mutateModelStateWithFormUpdate(s => s.Section13.AboRhFactor.BloodGroup = bloodGroup),
                            hasEmptyItem: true,
                            className: "max-height-combo-box"
                        }),
                        className: "flex-column margin-sm-right flex-grow-1"
                    })}
                    {this.renderField({
                        label: "ObstetricalFile_BloodRhesusFactorAbbrevLabel",
                        field: this.controlRenderer.renderComboBox({
                            id: "bloodRhesus-InvestigationsAboRhFactor",
                            selectedCode: section13.BloodRhesus,
                            items: this.controlRenderer.getBloodRhesusOptions(),
                            onChange: bloodRhesus => this.props.mutateModelStateWithFormUpdate(s => s.Section13.AboRhFactor.BloodRhesus = bloodRhesus),
                            hasEmptyItem: true,
                            className: "max-height-combo-box"
                        }),
                        className: "flex-column flex-grow-1"
                    })}
                </div>
                <div className="flex-display flex-col-gap-xs nowrap">
                    {this.renderLabelAndDatePickersColumn(
                        "AntibodyTitreLabel",
                        section13.FirstAntibodyTitreDate,
                        section13.SecondAntibodyTitreDate,
                        value => this.props.mutateModelStateWithFormUpdate(s => s.Section13.AboRhFactor.FirstAntibodyTitreDate = value),
                        value => this.props.mutateModelStateWithFormUpdate(s => s.Section13.AboRhFactor.SecondAntibodyTitreDate = value)
                    )}
                    <div>
                        {this.renderField({
                            field: (
                                <div className="field-value field-value-input">
                                    {this.controlRenderer.renderTextbox({
                                        value: section13.FirstAntibodyTitreValue,
                                        onChange: value => this.props.mutateModelState(s => s.Section13.AboRhFactor.FirstAntibodyTitreValue = value),
                                        style: { height: "36px" },
                                        maxLength: 40
                                    })}
                                </div>
                            )
                        })}
                        {this.controlRenderer.renderTextbox({
                            value: section13.SecondAntibodyTitreValue,
                            onChange: value => this.props.mutateModelState(s => s.Section13.AboRhFactor.SecondAntibodyTitreValue = value),
                            style: { height: "36px" },
                            maxLength: 40
                        })}
                    </div>
                </div>
                {this.renderLabelAndDatePickersColumn(
                    "ObstetricalFile_DateRhImmuneGlobulinLabel",
                    section13.FirstRhImmuneGlobulinDate,
                    section13.SecondRhImmuneGlobulinDate,
                    value => this.props.mutateModelStateWithFormUpdate(s => s.Section13.AboRhFactor.FirstRhImmuneGlobulinDate = value),
                    value => this.props.mutateModelStateWithFormUpdate(s => s.Section13.AboRhFactor.SecondRhImmuneGlobulinDate = value)
                )}
                <div>
                    {this.renderField({
                        label: "HemoglobinLabel",
                        field: (
                            <div className="field-and-label-container flex-col-gap-sm min-height-empty-value">
                                <label style={{ width: "10px" }}>{this.HemoglobinFirstTrimesterLabel}</label>
                                {this.controlRenderer.renderTextbox({
                                    value: section13.HemoglobinFirstTrimester,
                                    onChange: value => this.props.mutateModelState(s => s.Section13.AboRhFactor.HemoglobinFirstTrimester = value),
                                    type: "number",
                                    maxLength: this.page2FieldLimits.Section13_Hemoglobin_FirstTrimester.MaxChars
                                })}
                            </div>
                        ),
                        className: "bc-antenatal-section-part10",
                        labelSuffix: this.getLabelSuffix(` (${this.getString("ObstetricalFile_GramLitreAbbrevUnitLabel")})`, "extra-info-label"),
                        labelClassName: "padding-lg-left"
                    })}
                    <div className="field bc-antenatal-section-part10">
                        <div className="field-and-label-container flex-col-gap-sm min-height-empty-value">
                            <label style={{ width: "10px" }}>{this.HemoglobinThirdTrimesterLabel}</label>
                            <div className="field-value field-value-input">
                                {this.controlRenderer.renderTextbox({
                                    value: section13.HemoglobinThirdTrimester,
                                    onChange: value => this.props.mutateModelState(s => s.Section13.AboRhFactor.HemoglobinThirdTrimester = value),
                                    type: "number",
                                    maxLength: this.page2FieldLimits.Section13_Hemoglobin_FirstTrimester.MaxChars
                                })}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    private renderLabelAndDatePickersColumn(
        label: string,
        firstRowDate: Date,
        secondRowDate: Date,
        onFirstRowDateChange: (date: Date) => void,
        onSecondRowDateChange: (date: Date) => void
    ): JSX.Element {
        return (
            <div>
                {this.renderField({
                    label: label,
                    field: (
                        <div className="field-and-label-container flex-col-gap-xs min-height-empty-value">
                            <label style={{ width: "10px" }}>1. </label>
                            {this.controlRenderer.renderDateSelector(
                                {
                                    value: firstRowDate,
                                    onChange: value => onFirstRowDateChange(value),
                                    width: 120
                                },
                                "nowrap"
                            )}
                        </div>
                    ),
                    className: "bc-antenatal-section-part10",
                    labelClassName: "padding-md-left"
                })}
                <div className="field bc-antenatal-section-part10">
                    <div className="field-and-label-container flex-col-gap-xs min-height-empty-value">
                        <label style={{ width: "10px" }}>2. </label>
                        <div className="field-value field-value-input">
                            {this.controlRenderer.renderDateSelector(
                                {
                                    value: secondRowDate,
                                    onChange: value => onSecondRowDateChange(value),
                                    width: 120
                                },
                                "nowrap"
                            )}
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export { BritishColumbiaObstetricalInvestigationsAboRhFactor };
